var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    {
      staticClass: "ma-0 px-6 py-0",
      attrs: { cols: _vm.field.cols ? _vm.field.cols : "4" }
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "", "nudge-top": "25px" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-col",
                    _vm._g(
                      { staticClass: "ma-0 pa-0" },
                      _vm.field.type === "section" ? null : on
                    ),
                    [
                      _vm.field.type === "date"
                        ? _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": true,
                                transition: "scale-transition",
                                "offset-y": "",
                                "nudge-left": "25",
                                "nudge-top": "25",
                                "max-width": "290px",
                                "min-width": "290px"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              attrs: {
                                                label: _vm.fieldLabel,
                                                "prepend-inner-icon":
                                                  "mdi-calendar",
                                                outlined: "",
                                                "background-color": "#fff",
                                                readonly: "",
                                                dense: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.payload[
                                                    "" + _vm.field.value
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.payload,
                                                    "" + _vm.field.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "payload[`${field.value}`]"
                                              }
                                            },
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("v-date-picker", {
                                attrs: {
                                  "allowed-dates": _vm.allowedDates,
                                  min: _vm.minDate,
                                  "no-title": ""
                                },
                                model: {
                                  value: _vm.payload["" + _vm.field.value],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.payload,
                                      "" + _vm.field.value,
                                      $$v
                                    )
                                  },
                                  expression: "payload[`${field.value}`]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm.field.type === "boolean"
                        ? _c("v-checkbox", {
                            attrs: { label: _vm.fieldLabel, dense: "" },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "select" &&
                          _vm.field.value === "hosting_file_type_id"
                        ? _c("v-autocomplete", {
                            attrs: {
                              disabled:
                                ["null", null].includes(
                                  _vm.payload.hosting_file_participation_id
                                ) || _vm.field.disabled,
                              label: _vm.fieldLabel,
                              outlined: "",
                              items:
                                _vm.listsByFieldValue[_vm.field.value] || [],
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "select" &&
                          _vm.field.value === "hosting_file_program_id"
                        ? _c("v-autocomplete", {
                            attrs: {
                              disabled:
                                (_vm.payload.hosting_file_participation_id !==
                                  "null" &&
                                  _vm.payload.hosting_file_participation_id !==
                                    _vm.adHostingId) ||
                                _vm.field.disabled,
                              label: _vm.fieldLabel,
                              outlined: "",
                              items:
                                _vm.listsByFieldValue[_vm.field.value] || [],
                              "item-text": "name",
                              "item-value": "id",
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "select" &&
                          _vm.field.value === "store_format"
                        ? _c("v-autocomplete", {
                            attrs: {
                              disabled:
                                !_vm.payload["start_date"] ||
                                _vm.field.disabled,
                              label: _vm.fieldLabel,
                              outlined: "",
                              "return-object": "",
                              items:
                                _vm.listsByFieldValue[_vm.field.value] || [],
                              "item-text": [
                                "ad_group_id",
                                "owner_id",
                                "division_id"
                              ].includes(_vm.field.value)
                                ? "name"
                                : "name",
                              "item-value": [
                                "ad_group_id",
                                "owner_id",
                                "division_id"
                              ].includes(_vm.field.value)
                                ? "id"
                                : "id",
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "select"
                        ? _c("v-autocomplete", {
                            attrs: {
                              disabled:
                                !_vm.payload["start_date"] ||
                                _vm.field.disabled,
                              label: _vm.fieldLabel,
                              outlined: "",
                              items:
                                _vm.listsByFieldValue[_vm.field.value] || [],
                              "item-text": [
                                "ad_group_id",
                                "owner_id",
                                "division_id"
                              ].includes(_vm.field.value)
                                ? "name"
                                : "name",
                              "item-value": [
                                "ad_group_id",
                                "owner_id",
                                "division_id"
                              ].includes(_vm.field.value)
                                ? "id"
                                : "id",
                              clearable: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "array"
                        ? _c("v-autocomplete", {
                            attrs: {
                              disabled: _vm.field.disabled,
                              label: _vm.fieldLabel,
                              multiple: "",
                              clearable: "",
                              outlined: "",
                              items:
                                _vm.listsByFieldValue[_vm.field.value] || [],
                              "item-text": "name",
                              "item-value": "id",
                              dense: ""
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                        : _vm.field.type === "section"
                        ? _c(
                            "v-container",
                            { staticClass: "mx-0 px-0 pt-2 pb-2" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mx-0 pa-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "font-weight-bold",
                                      attrs: { align: "start" }
                                    },
                                    [_vm._v(" " + _vm._s(_vm.fieldLabel) + " ")]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticClass: "my-0" },
                                    _vm._l(_vm.field.sectionFields, function(
                                      subfield
                                    ) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: subfield.value,
                                          staticClass: "mx-0 px-3 pt-4 pb-0",
                                          attrs: {
                                            cols: subfield.cols
                                              ? subfield.cols
                                              : "2"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                "nudge-top": "25px"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g({}, on),
                                                          [
                                                            (subfield.type ===
                                                              "string" ||
                                                              subfield.type ===
                                                                "number") &&
                                                            ![
                                                              "equipment"
                                                            ].includes(
                                                              subfield.value
                                                            )
                                                              ? _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        subfield.type,
                                                                      label: _vm.subfieldLabel(
                                                                        subfield
                                                                      ),
                                                                      disabled:
                                                                        (_vm
                                                                          .field
                                                                          .value ===
                                                                          "rebate" &&
                                                                          _vm
                                                                            .payload
                                                                            .rebate
                                                                            .paying_option_id !=
                                                                            _vm.checkId) ||
                                                                        (_vm
                                                                          .field
                                                                          .value ===
                                                                          "pos_contact" &&
                                                                          ![
                                                                            _vm.scanOnlyId,
                                                                            _vm.scanAndBillbackId
                                                                          ].includes(
                                                                            _vm
                                                                              .payload
                                                                              .billing_program_type_id
                                                                          )) ||
                                                                        subfield.disabled,
                                                                      outlined:
                                                                        "",
                                                                      "hide-spin-buttons":
                                                                        "",
                                                                      "background-color":
                                                                        "#fff",
                                                                      dense: ""
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.validate(
                                                                          $event,
                                                                          _vm
                                                                            .field
                                                                            .value,
                                                                          subfield.value
                                                                        )
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .payload[
                                                                          "" +
                                                                            _vm
                                                                              .field
                                                                              .value
                                                                        ][
                                                                          "" +
                                                                            subfield.value
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .payload[
                                                                            "" +
                                                                              _vm
                                                                                .field
                                                                                .value
                                                                          ],
                                                                          "" +
                                                                            subfield.value,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "payload[`${field.value}`][`${subfield.value}`]"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            subfield.value.includes(
                                                              "equipment"
                                                            )
                                                              ? _c(
                                                                  "v-textarea",
                                                                  {
                                                                    attrs: {
                                                                      dense: "",
                                                                      rows: "4",
                                                                      label: _vm.subfieldLabel(
                                                                        subfield
                                                                      ),
                                                                      disabled:
                                                                        ![
                                                                          _vm.scanOnlyId,
                                                                          _vm.scanAndBillbackId
                                                                        ].includes(
                                                                          _vm
                                                                            .payload
                                                                            .billing_program_type_id
                                                                        ) ||
                                                                        subfield.disabled,
                                                                      outlined:
                                                                        ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .payload[
                                                                          "" +
                                                                            _vm
                                                                              .field
                                                                              .value
                                                                        ][
                                                                          "" +
                                                                            subfield.value
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .payload[
                                                                            "" +
                                                                              _vm
                                                                                .field
                                                                                .value
                                                                          ],
                                                                          "" +
                                                                            subfield.value,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "payload[`${field.value}`][`${subfield.value}`]"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            subfield.value ===
                                                            "pos_brand_id"
                                                              ? _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      label: _vm.subfieldLabel(
                                                                        subfield
                                                                      ),
                                                                      disabled:
                                                                        ![
                                                                          _vm.scanOnlyId,
                                                                          _vm.scanAndBillbackId
                                                                        ].includes(
                                                                          _vm
                                                                            .payload
                                                                            .billing_program_type_id
                                                                        ) ||
                                                                        subfield.disabled,
                                                                      items:
                                                                        _vm.brandList,
                                                                      outlined:
                                                                        "",
                                                                      "item-text":
                                                                        "name",
                                                                      "item-value":
                                                                        "id",
                                                                      clearable:
                                                                        "",
                                                                      dense: ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .payload[
                                                                          "" +
                                                                            _vm
                                                                              .field
                                                                              .value
                                                                        ][
                                                                          "" +
                                                                            subfield.value
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .payload[
                                                                            "" +
                                                                              _vm
                                                                                .field
                                                                                .value
                                                                          ],
                                                                          "" +
                                                                            subfield.value,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "payload[`${field.value}`][`${subfield.value}`]"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            subfield.type ===
                                                              "select" &&
                                                            subfield.value !=
                                                              "pos_brand_id"
                                                              ? _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      label: _vm.subfieldLabel(
                                                                        subfield
                                                                      ),
                                                                      items:
                                                                        subfield.value ===
                                                                        "paying_option_id"
                                                                          ? _vm.paymentTypes
                                                                          : _vm
                                                                              .listsByFieldValue[
                                                                              subfield
                                                                                .value
                                                                            ] ||
                                                                            [],
                                                                      disabled:
                                                                        (_vm
                                                                          .field
                                                                          .value ===
                                                                          "rebate" &&
                                                                          subfield.value !=
                                                                            "paying_option_id" &&
                                                                          _vm
                                                                            .payload
                                                                            .rebate
                                                                            .paying_option_id !=
                                                                            _vm.checkId) ||
                                                                        (_vm
                                                                          .field
                                                                          .value ===
                                                                          "pos_contact" &&
                                                                          ![
                                                                            _vm.scanOnlyId,
                                                                            _vm.scanAndBillbackId
                                                                          ].includes(
                                                                            _vm
                                                                              .payload
                                                                              .billing_program_type_id
                                                                          )) ||
                                                                        subfield.disabled,
                                                                      filter:
                                                                        subfield.value ===
                                                                        "state"
                                                                          ? _vm.getStateList
                                                                          : function() {},
                                                                      outlined:
                                                                        "",
                                                                      "item-text":
                                                                        "name",
                                                                      "item-value":
                                                                        "id",
                                                                      clearable:
                                                                        "",
                                                                      dense: ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .payload[
                                                                          "" +
                                                                            _vm
                                                                              .field
                                                                              .value
                                                                        ][
                                                                          "" +
                                                                            subfield.value
                                                                        ],
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .payload[
                                                                            "" +
                                                                              _vm
                                                                                .field
                                                                                .value
                                                                          ],
                                                                          "" +
                                                                            subfield.value,
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "payload[`${field.value}`][`${subfield.value}`]"
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    subfield.tooltip ||
                                                      subfield.label
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("v-text-field", {
                            attrs: {
                              disabled: _vm.field.disabled,
                              type: _vm.field.type,
                              prefix:
                                _vm.field.value === "weekly_sales" ? "$" : "",
                              maxLength:
                                _vm.field.value === "store_number" ? 4 : 99,
                              label: _vm.fieldLabel,
                              "error-messages": _vm.errorMessage,
                              outlined: "",
                              "hide-spin-buttons": "",
                              "background-color": "#fff",
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.validate($event, _vm.field.value)
                              }
                            },
                            model: {
                              value: _vm.payload["" + _vm.field.value],
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "" + _vm.field.value, $$v)
                              },
                              expression: "payload[`${field.value}`]"
                            }
                          })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [_c("span", [_vm._v(_vm._s(_vm.field.tooltip || _vm.field.label))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }